import { Component } from '@angular/core';
import { UserService } from '../shared/services/user.service';
import { AuthService } from '../shared/services/auth.service';
import { NbMenuItem } from '@nebular/theme';
import { Router, ActivatedRoute} from '@angular/router';
import { HttpErrorResponse } from '@angular/common/http';



@Component({
  selector: 'ngx-pages',
  styleUrls: ['pages.component.scss'],
  template: `
    <ngx-one-column-layout>
      <nb-menu [items]="menuArray" autoCollapse="true"></nb-menu>
      <router-outlet></router-outlet>
    </ngx-one-column-layout>
  `,
})
export class PagesComponent {
  
 
  permissionList : any;

  showDB= false;

  showCOM= false;
  showEM= false;
  showSM= false;
  showCM= false;
  showVH= false;
 
  showIM= false;

  showQUO= false; 
  showINV= false;
  showRECEIPT= false;

  showEXP= false;

  showMACC= false;
  showCB_ENTRY= false;
  showCHQ= false;
  showCB_BAL= false;

  showRPT_CB= false;
  showRPT_SALE= false;
  showRPT_INV= false;
  showRPT_EXP= false;
  showRPT_PNL= false;

  showUSER= false;
  showSETTINGS= false;
  showBACKUP= false;
  showFILE= false;

 

  menuArray :  NbMenuItem[]=[];

  roles: string[];
  username: string;


  constructor (private userService: UserService,
    private authService: AuthService,
    private router : Router,
    private route : ActivatedRoute,
    ){

    }



ngOnInit() {

this.getUserLoggedData();
this.getUserPermissionByUserName();
}

getUserLoggedData() : void {
  this.username = this.authService.getUserLoggedIn();
}

  

getUserPermissionByUserName(){ 
      this.userService.getUserPermission(this.username)
      .subscribe(
        (res)=> {    
          this.authService.controlPermissionArray  = res;
            this.assignRoles(this.authService.controlPermissionArray);
   
        },
        (err) => {
          if(err instanceof HttpErrorResponse){                 
            if(err.status == 401){
              this.router.navigate(['/login']);
            }
          }
          console.log(err);
        });   

  }
  

  assignRoles(roles: any []){

    this.showDB=!!roles[0].module;
    this.showCOM=!!roles[1].module;
    this.showEM=!!roles[2].module;
    this.showSM=!!roles[3].module;
    this.showCM=!!roles[4].module;
    this.showVH=!!roles[5].module;
    this.showIM=!!roles[6].module;
    this.showQUO=!!roles[7].module;
    this.showINV=!!roles[8].module;
    this.showRECEIPT=!!roles[9].module;
    this.showEXP=!!roles[10].module;
    this.showMACC=!!roles[11].module;
    this.showCB_ENTRY=!!roles[12].module;
    this.showCHQ=!!roles[13].module;
    this.showCB_BAL=!!roles[14].module;
    this.showRPT_CB=!!roles[15].module;
    this.showRPT_SALE=!!roles[16].module;
    this.showRPT_INV=!!roles[17].module;
    this.showRPT_EXP=!!roles[18].module;
    this.showRPT_PNL=!!roles[19].module;
    this.showUSER=!!roles[20].module;
    this.showSETTINGS=!!roles[21].module;
    this.showBACKUP=!!roles[22].module;
    this.showFILE=!!roles[23].module;
    
    if(this.showDB){
      this.router.navigate(['/pages/dashboard']);
      }
     
     this.menuArray = [
      {
        title: 'Dashboard',
        icon: 'keypad-outline',
        link: './dashboard',
        home: true,
        hidden:  !this.showDB,
      },
      
      {
        title: 'Master Files',
        icon: 'grid-outline',
        hidden:  !this.showCOM && !this.showEM && !this.showSM && !this.showCM && !this.showVH,
        children: [
          {
            title: 'Company Profile',
            link: './master-files/company-profile',
            hidden:  !this.showCOM,
          },
          {
            title: 'Employee Master',
            link: './master-files/employee-list',
            hidden:  !this.showEM,
          },
          {
            title: 'Supplier Master',
            link: './master-files/supplier-list',
            hidden:  !this.showSM,
          },
          {
            title: 'Customer Master',
            link: './master-files/customer-list',
            hidden:  !this.showCM,
          },
          {
            title: 'Vehicle Register',
            link: './master-files/vehicle-list',
            hidden:  !this.showVH,
          },
        ],
      },    

    {
        title: 'Inventory',
        icon: 'layers-outline',
        hidden:  !this.showIM,
        children: [
          {
            title: 'Item Master',
            link: './products/item-list',
            hidden:  !this.showIM,
          },     
        ],
      },
      // {
      //   title: 'Purchase',
      //   icon: 'shopping-cart-outline',
      //   hidden:  !this.showPO && !this.showPI && !this.showPR && !this.showPMT,
      //   children: [
      //     {
      //       title: 'Purchase Order',
      //       link: './purchase/purchase-order-list',
      //       hidden:  !this.showPO,
      //     },
      //     {
      //       title: 'Purchase Invoice',
      //       link: './purchase/purchase-invoice-list',
      //       hidden:  !this.showPI,
      //     },
      //     {
      //       title: 'Purchase Return',
      //       link: './purchase/purchase-return-list',
      //       hidden:  !this.showPR,
      //     },
      //     {
      //       title: 'Payment',
      //       link: './purchase/payment-list',
      //       hidden:  !this.showPMT,
      //     },
      //   ],
      // },
      {
        title: 'Sale',
        icon: 'file-text-outline',
        hidden:  !this.showQUO &&  !this.showINV  && !this.showRECEIPT,
        children: [
          {
            title: 'Quotation',
            link: './customer/quotation-list',
            hidden:  !this.showQUO,
          },
          {
            title: 'Invoice',
            link: './customer/invoice-list',
            hidden:  !this.showINV,
          },
          // {
          //   title: 'Sales Return',
          //   link: './customer/sale-return-list',
          //   hidden:  !this.showSR,
          // },
          {
            title: 'Receipt',
            link: './customer/receipt-list',
            hidden:  !this.showRECEIPT,
          },
        ],
      },
      {
        title: 'Expense',
        icon: 'browser-outline',
        link: './expenses/expense-list',
        hidden:  !this.showEXP,
      },
      {
        title: 'Cash & Bank',
        icon: 'credit-card-outline',
        hidden:  !this.showMACC && !this.showCB_ENTRY&& !this.showCHQ && !this.showCB_BAL,
        children: [
          {
            title: 'Manage Accounts',
            link: './cash&banks/manage-accounts',
            hidden:  !this.showMACC,
          },
          {
            title: 'Cash & Bank Entry',
            link: './cash&banks/cash&bank-entry-list',
            hidden:  !this.showCB_ENTRY,
          },
          {
            title: 'Cheques',
            link: './cash&banks/cheque-list',
            hidden:  !this.showCHQ,
          },
          {
            title: 'Cash & Bank Balances',
            link: './cash&banks/cash-flow-statement',
            hidden:  !this.showCB_BAL,
          },
        ],
      },
      {
        title: 'Reports',
        icon: 'pie-chart-outline',
        hidden:  !this.showRPT_CB &&  !this.showRPT_SALE &&  !this.showRPT_INV &&  !this.showRPT_EXP &&  !this.showRPT_PNL,
        children: [
          {
            title: 'Customer Outstanding Report',
            link: './reports/customer-outstanding-report',
            hidden:  !this.showRPT_CB,
          },
          // {
          //   title: 'Supplier Outstanding Report',
          //   link: './reports/supplier-outstanding-report',
          //   hidden:  !this.showRPT_SB,
          // },
          // {
          //   title: 'Purchase Report',
          //   link: './reports/purchase-report',
          //   hidden:  !this.showRPT_PUR,
          // },
          {
            title: 'Sales Report',   
            link: './reports/sales-report',        
            hidden:  !this.showRPT_SALE,
          },
          {
            title: 'Invoice Report',   
            link: './reports/invoice-report',        
            hidden:  !this.showRPT_SALE,
          },
          {
            title: 'Expense Report',
            link: './reports/expense-report',
            hidden:  !this.showRPT_EXP,
          },
          {
            title: 'Profit & Loss Statement',
            link: './reports/profit-and-loss-statement',
            hidden:  !this.showRPT_PNL,
          },
        ],
      },
      {
        title: 'Users',
        icon: 'person-done-outline',
        hidden:  !this.showUSER,
        children: [
          {
            title: 'User Types',
            link: './user-management/user-types',
          },
          {
            title: 'User',
            link: './user-management/user-list',
          },
          {
            title: 'User Permission',
            link: './user-management/user-permission',
          },
          {
            title: 'Reset Password',
            link: './user-management/reset-password-request-list',
          },
        ],
      },
      {
        title: 'Settings',
        icon: 'settings-2-outline',
        link: './settings',
        hidden:  !this.showSETTINGS,
      },

      {
        title: 'Backup',
        icon: 'hard-drive',
        link: './backup',
        hidden:  !this.showBACKUP,
      },

     ]
     
   }

}
